// extracted by mini-css-extract-plugin
export default {"root":"Activity_root__qOHOq","activityIcon":"Activity_activityIcon__0d5lt","activityIconWrapper":"Activity_activityIconWrapper__d7L0r"};